// extracted by mini-css-extract-plugin
export default {"root":"style_root__T36Rr","icon":"style_icon__jf+++"};